export default __webpack_public_path__ + "static/iaccp-64cc10d839ddece3b56de8d8e2e5d710.jpg";